// @file Timer for pausing and resuming

type TimerStatus = 'running' | 'paused' | 'stopped' | 'resumed'

export class PausableTimer {
  private timeoutId: ReturnType<typeof setInterval> | undefined
  private startTime!: number
  private remainingTime!: number
  private timeoutDuration!: number
  public status: TimerStatus = 'stopped'
  private onComplete!: () => void

  setOnComplete(onComplete: () => void): void {
    this.onComplete = onComplete
  }

  setTimeoutDuration(timeoutDuration: number): void {
    this.timeoutDuration = timeoutDuration
  }

  pause(): void {
    this.remainingTime -= Date.now() - this.startTime
    this.status = 'paused'

    if (this.timeoutId !== undefined) {
      clearTimeout(this.timeoutId)
    }
  }

  stop(): void {
    this.remainingTime = 0
    this.status = 'stopped'

    if (this.timeoutId !== undefined) {
      clearTimeout(this.timeoutId)
    }
  }

  restartTimeout(): void {
    this.startTime = Date.now()
    this.timeoutId = setTimeout(this.onComplete, this.remainingTime)
  }

  resume(): void {
    this.restartTimeout()
    this.status = 'resumed'
  }

  start(): void {
    this.stop()
    this.remainingTime = this.timeoutDuration
    this.restartTimeout()
    this.status = 'running'
  }

  get timeLeft(): number {
    return this.remainingTime - (Date.now() - this.startTime)
  }

  get isPaused(): boolean {
    return this.status === 'paused'
  }

  get isResumed(): boolean {
    return this.status === 'resumed'
  }
}
